// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-selectable-article {
  margin: 0px 0;
  width: 100%;
  background: white;
  border: var(--outline-default);
  border-radius: var(--radius-default);
}
.item-selectable-article.selected {
  border: 1px solid var(--color-black);
}

.card-content {
  padding: 0;
  width: 100%;
}

.default-img {
  object-fit: contain !important;
  padding: 5px;
}

.content-wrapper {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  gap: 16px;
  min-height: 90px;
}

.left-section {
  position: relative;
  flex-shrink: 0;
  width: 80px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.item-selectable-article-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.selected-icon {
  width: 18px;
  height: 24px;
  position: absolute;
  top: -15px;
  left: -4px;
  z-index: 10;
  --icon-color: var(--ion-color-primary);
}

.middle-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  min-width: 0;
}

.name {
  font-family: AppFontMedium;
  font-size: 16px;
  color: var(--color-black);
  line-height: 1.3;
  word-break: break-word;
  display: flex;
  align-items: center;
  gap: 4px;
}

.option-price {
  font-size: 14px;
  color: var(--color-grey);
}

.right-section {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.select-button {
  padding: 10px 24px;
  background: #e6e6e6;
  font-size: 14px;
  font-family: AppFont;
  color: var(--color-black);
  border: none;
  border-radius: var(--radius-default);
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 90px;
  height: 40px;
  white-space: nowrap;
}
.select-button:hover {
  background: #e5e3de;
}
.select-button:active {
  background: #d9d7d2;
}

.item-selectable-article.selected .select-button {
  background: var(--ion-color-secondary);
  color: var(--color-white);
}

app-quantity-selector {
  filter: drop-shadow(0px 2px 10px rgba(0, 0, 0, 0.1));
}

@media (max-height: 700px) {
  .content-wrapper {
    gap: 12px;
    padding: 10px 12px;
  }
  .left-section {
    width: 60px;
    height: 50px;
  }
  .name {
    font-size: 14px;
  }
  .select-button {
    min-width: 75px;
    padding: 8px 16px;
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/item-selectable-article/item-selectable-article.component.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,WAAA;EACA,iBAAA;EACA,8BAAA;EACA,oCAAA;AACD;AAEC;EACC,oCAAA;AAAF;;AAIA;EACC,UAAA;EACA,WAAA;AADD;;AAIA;EACC,8BAAA;EACA,YAAA;AADD;;AAIA;EACC,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;AADD;;AAIA;EACC,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AADD;;AAIA;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AADD;;AAIA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,sCAAA;AADD;;AAIA;EACC,OAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;AADD;;AAIA;EACC,0BAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AADD;;AAIA;EACC,eAAA;EACA,wBAAA;AADD;;AAIA;EACC,cAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AADD;;AAIA;EACC,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,yBAAA;EACA,YAAA;EACA,oCAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;AADD;AAGC;EACC,mBAAA;AADF;AAIC;EACC,mBAAA;AAFF;;AAMA;EACC,sCAAA;EACA,yBAAA;AAHD;;AAMA;EACC,oDAAA;AAHD;;AAOA;EACC;IACC,SAAA;IACA,kBAAA;EAJA;EAOD;IACC,WAAA;IACA,YAAA;EALA;EAQD;IACC,eAAA;EANA;EASD;IACC,eAAA;IACA,iBAAA;IACA,eAAA;EAPA;AACF","sourcesContent":[".item-selectable-article {\n\tmargin: 0px 0;\n\twidth: 100%;\n\tbackground: white;\n\tborder: var(--outline-default);\n\tborder-radius: var(--radius-default);\n\t// transition: border 200ms linear;\n\n\t&.selected {\n\t\tborder: 1px solid var(--color-black);\n\t}\n}\n\n.card-content {\n\tpadding: 0;\n\twidth: 100%;\n}\n\n.default-img {\n\tobject-fit: contain !important;\n\tpadding: 5px;\n}\n\n.content-wrapper {\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 12px 16px;\n\tgap: 16px;\n\tmin-height: 90px;\n}\n\n.left-section {\n\tposition: relative;\n\tflex-shrink: 0;\n\twidth: 80px;\n\theight: 60px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.item-selectable-article-image {\n\twidth: 100%;\n\theight: 100%;\n\tobject-fit: cover;\n}\n\n.selected-icon {\n\twidth: 18px;\n\theight: 24px;\n\tposition: absolute;\n\ttop: -15px;\n\tleft: -4px;\n\tz-index: 10;\n\t--icon-color: var(--ion-color-primary);\n}\n\n.middle-section {\n\tflex: 1;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\tgap: 4px;\n\tmin-width: 0; // Allow text to wrap\n}\n\n.name {\n\tfont-family: AppFontMedium;\n\tfont-size: 16px;\n\tcolor: var(--color-black);\n\tline-height: 1.3;\n\tword-break: break-word;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 4px;\n}\n\n.option-price {\n\tfont-size: 14px;\n\tcolor: var(--color-grey);\n}\n\n.right-section {\n\tflex-shrink: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-end;\n}\n\n.select-button {\n\tpadding: 10px 24px;\n\tbackground: #e6e6e6;\n\tfont-size: 14px;\n\tfont-family: AppFont;\n\tcolor: var(--color-black);\n\tborder: none;\n\tborder-radius: var(--radius-default);\n\tcursor: pointer;\n\ttransition: all 0.2s ease;\n\tmin-width: 90px;\n\theight: 40px;\n\twhite-space: nowrap;\n\n\t&:hover {\n\t\tbackground: #e5e3de;\n\t}\n\n\t&:active {\n\t\tbackground: #d9d7d2;\n\t}\n}\n\n.item-selectable-article.selected .select-button {\n\tbackground: var(--ion-color-secondary);\n\tcolor: var(--color-white);\n}\n\napp-quantity-selector {\n\tfilter: drop-shadow(0px 2px 10px rgba(0, 0, 0, 0.1));\n}\n\n// Responsive adjustments for smaller screens\n@media (max-height: 700px) {\n\t.content-wrapper {\n\t\tgap: 12px;\n\t\tpadding: 10px 12px;\n\t}\n\n\t.left-section {\n\t\twidth: 60px;\n\t\theight: 50px;\n\t}\n\n\t.name {\n\t\tfont-size: 14px;\n\t}\n\n\t.select-button {\n\t\tmin-width: 75px;\n\t\tpadding: 8px 16px;\n\t\tfont-size: 13px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
